import { render } from "./Bindings.vue?vue&type=template&id=6bf065af&scoped=true"
import script from "./Bindings.vue?vue&type=script&lang=js"
export * from "./Bindings.vue?vue&type=script&lang=js"

import "./Bindings.vue?vue&type=style&index=0&id=6bf065af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf065af"],['__file',"src/components/bindings/Bindings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bf065af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bf065af', __exports__)) {
    api.reload('6bf065af', __exports__)
  }
  
  module.hot.accept("./Bindings.vue?vue&type=template&id=6bf065af&scoped=true", () => {
    api.rerender('6bf065af', render)
  })

}


export default __exports__